import { ReservationDetail } from "@/model/ReservationDetail";
import State from "@/store/reservation/state";
import { Support } from "@/model/Support";

const mutations = {
  setUketsukeCd(state: State, payload: string) {
    Object.assign(state, { uketsukeCd: payload });
  },
  init(state: State, payload: ReservationDetail) {
    Object.assign(state, payload, {
      isLoadUketsuke: true
    });
    mutations.saveState(state);
    if (payload.uketsuke.uketsukeCd) {
      Object.assign(state, { uketsukeCd: payload.uketsuke.uketsukeCd });
    }
    if (payload.sknUketsukeExtends.id) {
      Object.assign(state, {
        uketsukeExtendsId: payload.sknUketsukeExtends.id
      });
    }
    if (payload.sknUketsukeExtends.yoyakuNo) {
      Object.assign(state, { yoyakuNo: payload.sknUketsukeExtends.yoyakuNo });
    }
    let soukouKm = payload.sknUketsukeExtends.soukouKm;
    if (soukouKm && typeof soukouKm == "string") {
      state.sknUketsukeExtends.soukouKm = Number(soukouKm);
    }
    let soukouMile = payload.sknUketsukeExtends.soukouMile;
    if (soukouMile && typeof soukouMile == "string") {
      state.sknUketsukeExtends.soukouMile = Number(soukouMile);
    }
  },
  updateMemo(state: State, payload: string) {
    state.sknUketsukeExtends.sknMemo = payload;
    mutations.saveState(state);
  },
  updateSoukouKm(state: State, payload: number) {
    state.sknUketsukeExtends.soukouKm = payload;
    mutations.saveState(state);
  },
  updateSoukouKmAvg(state: State, payload: number) {
    state.sknUketsukeExtends.soukouKmAvg = payload;
    mutations.saveState(state);
  },
  updateSoukouMile(state: State, payload: number) {
    state.sknUketsukeExtends.soukouMile = payload;
    mutations.saveState(state);
  },
  updateSoukouMileAvg(state: State, payload: number) {
    state.sknUketsukeExtends.soukouMileAvg = payload;
    mutations.saveState(state);
  },
  updateSoukouUnitKbn(state: State, payload: number) {
    state.sknUketsukeExtends.soukouUnitKbn = +payload;
    mutations.saveState(state);
  },
  updateSoukouBikouKbn(state: State, payload: number) {
    state.sknUketsukeExtends.soukouBikouKbn = +payload;
    mutations.saveState(state);
  },
  updateLaborRate(state: State, payload: number) {
    //laborRateKingakuZn
    state.sknUketsukeExtends.laborRateKingakuZn = payload;
    mutations.saveState(state);
  },
  initSupport(state: State, payload: Support[]) {
    state.support = payload;
  },
  updateFrontStaff(
    state: State,
    payload: { staffCd: string; staffNm: string }
  ) {
    state.frontStaff = payload.staffNm;
    state.sknUketsukeExtends.frontTantoushaCd = payload.staffCd;
    state.sknUketsukeExtends.frontTantoushaNm = payload.staffNm;
    mutations.saveState(state);
  },
  updateOmonaYouto(
    state: State,
    payload: { omonaYouto: number; omonaYoutoNm: string }
  ) {
    state.sknUketsukeExtends.omonaYouto = payload.omonaYouto;
    state.sknUketsukeExtends.omonaYoutoNm = payload.omonaYoutoNm;
    mutations.saveState(state);
  },
  restoreState(state: State) {
    const detail = window.localStorage.getItem(getKey());
    if (detail) {
      const objDetail = JSON.parse(detail);
      mutations.init(state, objDetail);
    }
  },
  clearState(state: State) {
    Object.assign(state, new State());
    window.localStorage.removeItem(getKey());
  },
  saveState(state: State) {
    window.localStorage.setItem(getKey(), JSON.stringify(state));
  },
  setIsStart(state: State, payload: boolean) {
    state.isStart = payload;
  },
  updateMakerModel(
    state: State,
    payload: {
      srMakerCd: string;
      srModelCd: string;
      srMakerNm: string;
      srModelNm: string;
    }
  ) {
    if (payload.srMakerCd) {
      state.uketsuke.srMakerCd = payload.srMakerCd;
    }
    if (payload.srModelCd) {
      state.uketsuke.srModelCd = payload.srModelCd;
    }
    if (payload.srMakerNm) {
      state.uketsuke.srMakerNm = payload.srMakerNm;
    }
    if (payload.srModelNm) {
      state.uketsuke.srModelNm = payload.srModelNm;
    }
  },
  updateConfirmation(state: State, payload: { num: number; value: number }) {
    state.sknUketsukeExtends["confirmationBeforeEntry" + payload.num] = payload.value;
  },
  updateRyoukinRankCd(state: State, payload: string) {
    state.sknUketsukeExtends.ryoukinRankCd = payload;
    mutations.saveState(state);
  },
  setUketsukeExtendsId(state: State, payload: number) {
    state.uketsukeExtendsId = payload;
    mutations.saveState(state);
  }
};
export default mutations;

function getKey() {
  let key = "reservation-detail";
  if (window.location.href.indexOf("user") > -1) {
    key += "-user";
  }
  return key;
}
